import Vue from 'vue';
import multiSelect from 'vue-multiselect';

Vue.use(multiSelect);

export default multiSelect;